import React from 'react';
import { Routes as ReactRoutes, Route, Navigate } from 'react-router-dom';
import { LandingPage } from '@/pages/LandingPage';

export const Routes: React.FC = () => {
    return (
        <ReactRoutes>
            <Route path="/" element={<LandingPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </ReactRoutes>
    );
};
